export default __webpack_public_path__ + "static/media/star-border.172c980b.svg";